import { Survey } from './types';

export const SURVEY: Survey = {
  source: {
    multiple: false,
    step: 1,
    values: {
      option: '',
      text: '',
    },
    controller: 'source',
    label: 'How did you hear about our product?',
    options: ['TikTok', 'Twitter', 'YouTube', 'Linekdin', 'Google Search', 'Colleague or friend referral', 'Other'],
  },
  industry: {
    multiple: false,
    step: 2,
    values: {
      option: '',
      text: '',
    },
    controller: 'industry',
    label: 'What is your company industry?',
    options: [
      'Blog / Influencer',
      'E-commerce',
      'Marketing',
      'EdTech',
      'Finance',
      'Gaming',
      'Video Production Agency',
      'TV / Media',
      'Other',
    ],
  },
  companySize: {
    multiple: false,
    step: 3,
    values: {
      option: '',
      text: '',
    },
    controller: 'companySize',
    label: 'Company size',
    options: ['1-10', '10-100', '100-300', '300+'],
  },
  importantFeatures: {
    multiple: true,
    step: 4,
    values: {
      option: [],
      text: '',
    },
    controller: 'importantFeatures',
    label: 'Which features are you interested in? (multiple select)',
    options: [
      'AI-dubbing (automated voice-over)',
      'Lip-sync (lip movement synchronization)',
      'Subtitles',
      'Voice cloning (replicating speaker`s voice)',
      'Video transcript generation',
      'Generating voice based on text ',
      'Real-time voice-over translation ',
      'Adding background music and audio effects',
      'Automated translation of graphic elements in video',
      'Removing noise and background music',
      'Other',
    ],
  },
  feedback: {
    multiple: false,
    step: 5,
    values: {
      option: [],
      text: '',
    },
    controller: 'feedback',
    label: 'Sample text',
    options: [],
  },
};
export const DEFAULT_VALUES = {
  source: {
    option: '',
    text: '',
  },
  importantFeatures: {
    option: [],
    text: '',
  },
  industry: {
    option: '',
    text: '',
  },
  companySize: {
    option: '',
    text: '',
  },
  feedback: {
    option: '',
    text: '',
  },
};
export const FORMS = ['source', 'importantFeatures', 'industry', 'companySize', 'feedback'];
